import React from 'react';
import { IconError } from '@common-web/icons';
import ErrorState from '@common-web/error-state';
import { strings } from '@constants/strings';

const ServerError = () => {
  return (
    <ErrorState heading={strings.oops_text} description={strings.temporary_issue_occurred} image={<IconError />} />
  );
};

export default ServerError;
